import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import api from '../api';

export default function RestrictedGuard() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    let cancelled = false;
    const check = async () => {
      try {
        const { data } = await api.get('user/profile/');
        const resumenOnly = !!data?.resumen_only;
        const planState = String(data?.plan_state || 'unknown');
        const restricted = resumenOnly || planState === 'expired';
        if (!restricted) return;
        const path = location.pathname || '';
        const allowed = path === '/resumen' || path === '/renovacion';
        if (!allowed && !cancelled) {
          navigate('/resumen', { replace: true });
        }
      } catch {
        // Si no hay sesión o falla la llamada, no redirigir desde aquí (ProtectedRoute cubrirá vistas protegidas)
      }
    };
    check();
    // Rechequear ante cambios de ruta
  }, [location, navigate]);

  return null;
}
